export default __webpack_public_path__ + "media/images/features/ja/kinosato-c29052e5821fe9fd1e78edfb7f9a761e.png";